import React, { useState } from "react";
import "./Login.scss";
import coins from "../../images/LoginPage/CryptooAntsLoginImage.svg";
import { serverAddr } from "./../../networkConfig";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function Login() {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!username.trim()) {
      setError("Username is required");
      return;
    }

    if (!password.trim()) {
      setError("Password is required");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const response = await serverAddr.post("auth/login/", {
        username: username,
        password: password
      }
      );

      const data = await response.json();

      if (response.ok) {
        console.log("Login Success:", data);

        // Example: save token
        if (data.token) {
          localStorage.setItem("token", data.token);
        }

        alert("Login Successful");
      } else {
        setError(data.message || "Invalid username or password");
      }

    } catch (err) {
      setError("Server error. Please try again.");
    }

    setLoading(false);
  };


  return (
    <div className="auth-wrapper">

      {/* LEFT SIDE IMAGE */}
      <div className="auth-left">
        <img src={coins} alt="crypto coins" />
      </div>

      {/* RIGHT SIDE CARD */}
      <div className="auth-right">
        <div className="auth-card">

          <div className="brand">
            <img
              src={require("../../images/LandingPage/Cryptoants.png")}
              alt="Logo"
              className="logo-img"
            />
            <h3>Login</h3>
          </div>

          <form onSubmit={handleSubmit}>

            {/* USERNAME */}
            <input
              type="text"
              placeholder="Username / Email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />

            {/* PASSWORD */}
            <div className="password-field">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <span
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </span>
            </div>

            {/* ERROR MESSAGE */}
            {error && <p className="error-text">{error}</p>}

            {/* BUTTON */}
            <button className="primary-btn" disabled={loading}>
              {loading ? "Signing In..." : "SIGN IN"}
            </button>

          </form>

        </div>
      </div>

    </div>
  );
}

export default Login;